import {ExternalLink, Typography} from '@sollapay/ui';

import type {FC} from 'react';

export interface FooterLinkProps {
  href: string;
  label: string;
}

export const FooterLink: FC<FooterLinkProps> = ({href, label}) => {
  return (
    <ExternalLink href={href} className="hover:underline">
      <Typography as="span" size="sm" color="secondary">
        {label}
      </Typography>
    </ExternalLink>
  );
};
